import React from 'react';
import Modal from './Modal';

const SpotCheckRejectionModal = ({ isOpen, handleClose, handleRestart, handleCancelWorkflow, documentCount }) => {
    return (
        isOpen && (
            <Modal
                header="Are you sure you want to reject all documents?"
                handleClose={handleClose}
                cancelButton={{
                    label: "Cancel Workflow",
                    variant: "danger",
                    onClick: handleCancelWorkflow,
                }}
                confirmButton={{
                    label: "Restart Workflow",
                    onClick: handleRestart,
                }}
            >
                <p>
                    All <span className='font-weight-semi-bold'>{documentCount}</span> documents in this workflow will be rejected. Would you like to restart or cancel this workflow?
                </p>
            </Modal>
        )
    );
};

export default SpotCheckRejectionModal;